import { type FunctionComponent } from 'react';
import { type FaqTabData, type ToolsTabData } from '../../../../types/project-about.types';
import { ResponsiveTabGroup, ResponsiveTab } from '../../../common-components/responsive-tabs/responsive-tabs.component';

type ProjectsAccordionProps = {
	data: FaqTabData[] | ToolsTabData[];
	getContent: (item: FaqTabData | ToolsTabData) => JSX.Element;
	getTitle: (item: FaqTabData | ToolsTabData) => string;
	onTabClick?: (index: number, title: string) => void;
};

export const ProjectsAccordion: FunctionComponent<ProjectsAccordionProps> = ({ data, getContent, getTitle, onTabClick }) => {
	const childContainerClasses = 'bb b--theme-grey-light';
	const tabContentClasses = 'f4 font-medium ph3';

	return (
		<ResponsiveTabGroup allowMultipleOpen={false} startingTabName={getTitle(data[0])} tabListClasses="" variant="accordion">
			{data.map((item, index) => {
				const tabTitle = getTitle(item);

				return (
					<ResponsiveTab
						key={tabTitle}
						name={tabTitle}
						childContainerClasses={`ph3 ${index === data.length - 1 ? '' : childContainerClasses}`}
						onClick={() => onTabClick?.(index, tabTitle)}
						tabClasses="pv3"
						tabContentClasses={tabContentClasses}
						variant="accordion"
						useAnimations={true}>
						{getContent(item)}
					</ResponsiveTab>
				);
			})}
		</ResponsiveTabGroup>
	);
};
